import { string, table } from "@rocicorp/zero";
import { addressFields, coreFields } from "./shared";

export const contact = table("contacts")
	.columns({
		...coreFields,
		...addressFields,
		orgId: string().from("org_id"),
		name: string(),
		state: string(),
		email: string().optional(),
		phone: string().optional(),
		fax: string().optional(),
		relatedContactId: string().from("related_contact_id").optional(),
		contactTypeId: string().from("contact_type_id"),
	})
	.primaryKey("id");
